/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './ward.reducer';

export const WardDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const wardEntity = useAppSelector(state => state.ward.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="wardDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.ward.detail.title">Ward</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.ward.id">Id</Translate>
            </span>
          </dt>
          <dd>{wardEntity.id}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="tinyMedicRestApp.ward.name">Name</Translate>
            </span>
          </dt>
          <dd>{wardEntity.name}</dd>
          <dt>
            <span id="tempClosed">
              <Translate contentKey="tinyMedicRestApp.ward.tempClosed">Temp Closed</Translate>
            </span>
          </dt>
          <dd>{wardEntity.tempClosed ? 'true' : 'false'}</dd>
          <dt>
            <span id="dateClosed">
              <Translate contentKey="tinyMedicRestApp.ward.dateClosed">Date Closed</Translate>
            </span>
          </dt>
          <dd>{wardEntity.dateClosed}</dd>
          <dt>
            <span id="description">
              <Translate contentKey="tinyMedicRestApp.ward.description">Description</Translate>
            </span>
          </dt>
          <dd>{wardEntity.description}</dd>
          <dt>
            <span id="info">
              <Translate contentKey="tinyMedicRestApp.ward.info">Info</Translate>
            </span>
          </dt>
          <dd>{wardEntity.info}</dd>
          <dt>
            <span id="roomNoStart">
              <Translate contentKey="tinyMedicRestApp.ward.roomNoStart">Room No Start</Translate>
            </span>
          </dt>
          <dd>{wardEntity.roomNoStart}</dd>
          <dt>
            <span id="roomNoEnd">
              <Translate contentKey="tinyMedicRestApp.ward.roomNoEnd">Room No End</Translate>
            </span>
          </dt>
          <dd>{wardEntity.roomNoEnd}</dd>
          <dt>
            <span id="roomPrefix">
              <Translate contentKey="tinyMedicRestApp.ward.roomPrefix">Room Prefix</Translate>
            </span>
          </dt>
          <dd>{wardEntity.roomPrefix}</dd>
          <dt>
            <span id="modifiedBy">
              <Translate contentKey="tinyMedicRestApp.ward.modifiedBy">Modified By</Translate>
            </span>
          </dt>
          <dd>{wardEntity.modifiedBy}</dd>
          <dt>
            <span id="modifiedTime">
              <Translate contentKey="tinyMedicRestApp.ward.modifiedTime">Modified Time</Translate>
            </span>
          </dt>
          <dd>{wardEntity.modifiedTime}</dd>
          <dt>
            <span id="createdBy">
              <Translate contentKey="tinyMedicRestApp.ward.createdBy">Created By</Translate>
            </span>
          </dt>
          <dd>{wardEntity.createdBy}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.ward.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{wardEntity.microSec}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.ward.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{wardEntity.timestampentry}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.ward.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{wardEntity.lastupdated}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.ward.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{wardEntity.cursor}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.ward.active">Active</Translate>
            </span>
          </dt>
          <dd>{wardEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="genderPolicy">
              <Translate contentKey="tinyMedicRestApp.ward.genderPolicy">Gender Policy</Translate>
            </span>
          </dt>
          <dd>{wardEntity.genderPolicy}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.ward.hospital">Hospital</Translate>
          </dt>
          <dd>{wardEntity.hospital ? wardEntity.hospital.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/ward" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/ward/${wardEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default WardDetail;
